// extracted by mini-css-extract-plugin
module.exports = {"select":"_19wDTs4-E0rsZQxoYF5h8W"};